import actionTypes from "./actionTypes";

export const themeController = () => {
    return {
        type: actionTypes.THEME
    }
}